import { useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon, ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { APIClient } from "../../../../helpers/api_helper";
import { GET_SETTING_BY_NAME } from "../../../../helpers/url_helper";
import { RewardsViewContext } from "../../../../context/Disclosures/rewards/rewardsContext";
import { Fifth } from "../../../buttons/Fifth";
import { Rewards } from "./Rewards";

const apiClient = new APIClient();

export function HowIncreaseLevelV2({ setOpenCharacter }) {
  const navigate = useNavigate();
  const { updateRewardsView, rewardsViewData } = useContext(RewardsViewContext);
  const [open, setOpen] = useState(false);
  const [, setLevelsConfig] = useState({});

  const handleGetLevelsConfig = async () => {
    try {
      let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
        name: "levels-config",
      });
      let value = data?.data?.value;
      let levels = value[0]?.levels;
      let youActions = value[0]?.youActions;
      let otherActions = value[0]?.otherActions;
      setLevelsConfig({ levels, youActions, otherActions });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDisclosure = () => {
    updateRewardsView({
      openDisclosure: false,
    });
    setOpen(false);
  };

  const handleOpen = () => {
    handleGetLevelsConfig();
    updateRewardsView({
      openDisclosure: true,
    });
    setOpen(true);
    if (setOpenCharacter) setOpenCharacter(false);
  };

  const handleRedirectToLevel = () => {
    updateRewardsView({
      openDisclosure: false,
    });
    setOpen(false);
    return navigate("/nivel-cliente");
  };

  const handleOpenDisclosureMyRewards = () => {
    updateRewardsView({
      ...rewardsViewData,
      openDisclosure: true,
      openDisclosureMyRewards: true,
    });
  };

  useEffect(() => {
    setOpen(rewardsViewData?.openDisclosure);
  }, [rewardsViewData?.openDisclosure]);

  return (
    <>
      <div className={"w-full"} onClick={handleOpen} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 font-bold text-tdark cursor-pointer">
              <span>Ver recompensas</span>
              <div className="w-4 h-auto grid content-center">
                <ArrowLongRightIcon />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={handleCloseDisclosure}
        className="relative z-50"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-transparent xl:bg-darkBgLight/75 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-y-auto">
          <div className="absolute inset-0">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleCloseDisclosure}
                            className="relative text-white focus:outline-hidden"
                            style={{ cursor: "pointer" }}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Nivel de cliente</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          {/* <Rewards /> */}
                        </div>
                      </div>
                      <div className=" px-4 pt-8 ">
                        <div className="text-grayP text-sm">
                          El nivel de cliente determina tu acceso a beneficios
                          como aumento de cupo, aumento de plazo y descuentos
                          sobre tarifas e intereses, además de desbloquear
                          mejoras a tu avatar
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="max-h-screen overflow-y-auto rounded-t-3xl bg-white h-full">
                    <div className="text-grayP pt-4 px-4">
                      <Fifth
                        onClick={handleRedirectToLevel}
                        type="button"
                        text="Cómo subir de nivel"
                      />
                    </div>

                    <div className="text-grayP pt-4 px-4">
                      <button
                        onClick={handleOpenDisclosureMyRewards}
                        type="button"
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="flex">Mis recompensas</div>
                      </button>
                    </div>

                    <div
                      className="text-grayP pt-4 px-4 display-none"
                      style={{ display: "none" }}
                    >
                      <Rewards />
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
